

export function createModal(id:string, title:string, content:string, settings, addListeners:Function) {
    const s = {
        leftInput: {},
        submitBtn: {},
        size: false,
        centered: false,
        closeBtn: false,
        draggable: false,
        rerender: true,
    };
    s.leftInput = (settings.leftInput !== undefined) ? settings.leftInput : s.leftInput;
    s.submitBtn = (settings.submitBtn !== undefined) ? settings.submitBtn : s.submitBtn;
    s.size = (settings.size !== undefined) ? settings.size : s.size;
    s.centered = (settings.centered !== undefined) ? settings.centered : s.centered;
    s.closeBtn = (settings.close !== undefined) ? settings.close : s.closeBtn;
    s.draggable = (settings.draggable !== undefined) ? settings.draggable : s.draggable;
    s.rerender = (settings.rerender !== undefined) ? settings.rerender : s.rerender;


    if (document.getElementById(id) != undefined){
        if (s.rerender){
            return updateModal(id, title, content);
        } else {
            return;
        }
    } else {
        let modal = `<div id="${id}" class="modal fade" role="dialog">
  <div class="modal-dialog`;
        if (s.size) {
            modal += ' modal-' + s.size;
        }
        if (s.centered){
            modal += ' modal-dialog-centered';
        }
        modal += `">
    <!-- Modal content-->
    <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
                <h4 class="modal-title">${title}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      <div class="modal-body">
        ${content}
      </div>
      <div class="modal-footer">`;
        if (!jQuery.isEmptyObject(s.closeBtn)) {
            modal += `<button type="button" class="btn btn-info waves-effect" data-bs-dismiss="modal">Schließen</button>`;
        }
        if (!jQuery.isEmptyObject(s.submitBtn)) {
            const data = (s.submitBtn.data !== undefined) ? s.submitBtn.data : '';
            modal += `<button class="${s.submitBtn.class} btn btn-light-success text-success font-weight-medium" type="button" ${data}>${s.submitBtn.text}</button>`;
        }
        modal += `</div>
        </div>
      </div>
    </div>`;
        $(document.body).append(modal);
        const myModal = new bootstrap.Modal(document.getElementById(id));
        myModal.show()

        addListeners($("#" + id)); // add listener

        return myModal;
    }
}

export function updateModal(id, title, content){
    const modal = $("#" + id);
    modal.find(".modal-title").html(title);
    modal.find(".modal-body").html(content);
    const existingModal = bootstrap.Modal.getInstance(document.getElementById(id));
    existingModal.show();
    return existingModal;
}